module.exports = __webpack_public_path__ + "img/icCheck.0aaf6ac3.svg";